module.exports = function (done, value) {
  return { value: value, done: !!done };
};



//////////////////
// WEBPACK FOOTER
// D:/xampp_bk/htdocs/xampp/organicshop/~/core-js/library/modules/_iter-step.js
// module id = ../../../../core-js/library/modules/_iter-step.js
// module chunks = 3